"use strict";
class DeveloperAgencyController {
    constructor($scope, $window, SSHttpService, SSUtilService, SSAlertService, SSUserService, SSConfirmationService, OTPService, Upload, SSEmailNotificationScheduleService) {
        const self = this;

        self.$scope = $scope;
        self.$window = $window;

        self.data = SHOWSUITE.data;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAlertService = SSAlertService;
        self.SSUserService = SSUserService;
        self.OTPService = OTPService;
        self.SSConfirmationService = SSConfirmationService;
        self.Upload = Upload;
        self.ScheduleService = SSEmailNotificationScheduleService;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;

        self.AVAILABILITY_BROKERS_ALL = SHOWSUITE.AVAILABILITY_BROKERS_ALL;
        self.availabilityOptions = [
            { value: null, label: '-- Use launch setting (default) --' },
            { value: 20,   label: 'All Associates' },
        ];

        // WEB-4489: commission claimable email section of the edit row (fortnightly allowed: report code 15)
        self.commissionFrequencyOptions = self.ScheduleService.getFrequencyOptions(true);
        self.resetCommissionEmail();

        self.getAgencies();
        self.getAppointedAgencies();
    }

    // API Calls

    getAgencies() {
        const self = this;

        self.agencies = null;
        // let params = {
        //     'format': 1
        // };

        loading(true);
        self.SSHttpService.getAPIRequest('agencies').then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data && response.data.agencies)) {
                return;
            }

            self.agencies = response.data.agencies;

            self.filterAvailableAgencies();
        });
    }

    getAppointedAgencies() {
        const self = this;

        self.agencyProjects = null;

        let url = 'sec/developer/agencies/';
        let params = {
            property_id: self.data.property.id,
            include: 'agencies',
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }
            if (!(response.data)) {
                return;
            }

            self.agencyProjects = response.data.property_agencies;

            self.filterAvailableAgencies();
        });
    }

    saveAgencyProject() {
        const self = this;

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data){
                if (!self.SSUtilService.validateForm(self, 'ctrl', jQuery('#AgencyProjectForm' + self.agencyProjectParams.id))) {
                    self.SSAlertService.warning('Missing Params!', 'Please fill in the required information.');
                    return;
                }

                if(self.agencyProjectParams.agency_commission_value !== undefined && self.agencyProjectParams.agency_commission_value !== null )
                {
                    if(!self.agencyProjectParams.agency_commission_type)
                    {
                        self.SSAlertService.warning('Missing Params!', 'Please select agency commission type.');
                        return;
                    }
                }

                if(self.agencyProjectParams.agency_commission_type || self.agencyProjectParams.agency_commission_gst_inclusive)
                {
                    if(self.agencyProjectParams.agency_commission_value === null || self.agencyProjectParams.agency_commission_value === undefined)
                    {
                        self.SSAlertService.warning('Missing Params!', 'Please enter agency commission.');
                        return;
                    }
                }

                if(self.agencyProjectParams.broker_incentives_value !== undefined && self.agencyProjectParams.broker_incentives_value !== null)
                {
                    if(!self.agencyProjectParams.broker_incentives_type)
                    {
                        self.SSAlertService.warning('Missing Params!', 'Please select agent incentive type.');
                        return;
                    }
                }

                if(self.agencyProjectParams.broker_incentives_type || self.agencyProjectParams.broker_incentives_gst_inclusive)
                {
                    if(self.agencyProjectParams.broker_incentives_value === null || self.agencyProjectParams.broker_incentives_value=== undefined )
                    {
                        self.SSAlertService.warning('Missing Params!', 'Please enter agent incentive.');
                        return;
                    }
                }

                // WEB-4467: same range the server accepts (empty = no starting number)
                let eoiStartingNo = self.agencyProjectParams.eoi_starting_no;
                if (eoiStartingNo !== undefined && eoiStartingNo !== null && eoiStartingNo !== ''
                    && !(Number.isInteger(Number(eoiStartingNo)) && eoiStartingNo >= 1 && eoiStartingNo <= 99999999)) {
                    self.SSAlertService.warning('Invalid EOI Starting No.', 'EOI starting number must be a whole number from 1 to 99999999, or left empty.');
                    return;
                }
                if (eoiStartingNo === undefined && jQuery('#AgencyProjectForm' + self.agencyProjectParams.id + ' .eoi-starting-no-input').val()) {
                    // A number input's model is undefined when the typed text is not a valid number
                    self.SSAlertService.warning('Invalid EOI Starting No.', 'EOI starting number must be a whole number from 1 to 99999999, or left empty.');
                    return;
                }

                self.agencyProjectErrors = {};

                // WEB-4467: decide before the save — the response below is merged into the row
                let isEoiStartingNoChanged = self.isEoiStartingNoChanged(self.findAgencyProject(self.agencyProjectParams.agency_id));

                let url = 'sec/developer/agencies/assign';
                if (self.agencyProjectParams.id) {
                    url = 'sec/developer/agencies/update';
                }

                loading(true);
                self.SSHttpService.postAPIRequest(url, self.agencyProjectParams).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.agencyProjectErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }

                    if (!self.agencyProjects) {
                        self.agencyProjects = [];
                    }

                    let newAgencyProject = response.data.agency_project;
                    let existingAgencyProject = self.findAgencyProject(newAgencyProject.agency_id);
                    if (existingAgencyProject) {
                        angular.merge(existingAgencyProject, newAgencyProject);
                    } else {
                        self.agencyProjects.push(newAgencyProject);
                    }
                    self.filterAvailableAgencies();

                    // WEB-4467: the EOI starting number is saved through its own endpoint, and only when it changed
                    let savedAgencyProject = existingAgencyProject || newAgencyProject;
                    if (!isEoiStartingNoChanged) {
                        self.SSAlertService.success('Agency Commission/Incentives saved successfully.');
                        self.hideAgencyProjectEditForm();
                        return;
                    }

                    // Keep the edit row open until the starting number is saved too. A newly assigned
                    // link now exists: switch the open form to it so a failed starting-number save is
                    // retried as an update, not a second assign.
                    savedAgencyProject.editable = 1;
                    if (!self.agencyProjectParams.id) {
                        self.agencyProjectParams.id = savedAgencyProject.id;
                        self.agencyProjects = self.agencyProjects.filter(function (_agencyProject) {
                            return !!_agencyProject.id;
                        });
                    }

                    self.saveEoiStartingNo(savedAgencyProject);
                });
        });
    }

    /**
     * WEB-4467: GET the EOI starting number of an agency–project link and the next EOI number
     * the server will assign, for the preview in the edit row.
     *
     * @param {Object} agencyProject The link being edited (needs agency_id).
     * @returns {void} Sets self.eoiNumbering ({agency_id, property_id, eoi_starting_no, next_eoi_no}),
     *                 or leaves it null when the call fails (the preview then shows "--").
     *
     * @remarks next_eoi_no = max(saved starting number, highest number already used + 1), so it
     *          reflects the SAVED starting number, not the value being typed. It refreshes after
     *          every save. Requests are tagged with the agency id so a slow reply for a row the
     *          user has since left cannot overwrite the preview of the row now open.
     */
    getEoiNumbering(agencyProject) {
        const self = this;

        self.eoiNumbering = null;
        self.eoiNumberingLoading = false;
        if (!agencyProject || !agencyProject.id || !agencyProject.agency_id) {
            return;
        }

        let agencyId = agencyProject.agency_id;
        let params = {
            property_id: self.data.property.id,
            agency_id: agencyId,
        };

        self.eoiNumberingLoading = true;
        self.SSHttpService.getAPIRequest('sec/developer/agencies/eoi-numbering', params).then(function (response) {
            if (self.agencyProjectParams.agency_id != agencyId) {
                return;
            }
            self.eoiNumberingLoading = false;

            if (response instanceof Error) {
                // Non-blocking: the rest of the form still works without the preview
                console.warn('WEB-4467: Unable to load the next EOI number.', response);
                return;
            }

            self.eoiNumbering = response.data && response.data.eoi_numbering ? response.data.eoi_numbering : null;
        });
    }

    /**
     * WEB-4467: SAVE the EOI starting number of an agency–project link, after the
     * commission/incentives save has succeeded (2FA was already verified by saveAgencyProject()).
     *
     * @param {Object} agencyProject The saved link in self.agencyProjects (updated in place).
     * @returns {void}
     *
     * @remarks An empty field clears the starting number (null), i.e. numbering simply continues
     *          from the highest number already used. On failure the edit row stays open with the
     *          server's message under the field; the commission/incentive part is already saved,
     *          so the toast says so.
     */
    saveEoiStartingNo(agencyProject) {
        const self = this;

        let params = {
            property_id: self.data.property.id,
            agency_id: agencyProject.agency_id,
            eoi_starting_no: self.normalizeEoiStartingNo(self.agencyProjectParams.eoi_starting_no),
        };

        loading(true);
        self.SSHttpService.postAPIRequest('sec/developer/agencies/eoi-numbering', params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                self.agencyProjectErrors = self.SSHttpService.parseErrors(response);
                self.SSAlertService.warning('EOI Starting No. not saved', 'Agency Commission/Incentives were saved, but the EOI starting number was not. Please correct it and submit again.');
                return;
            }

            let eoiNumbering = response.data && response.data.eoi_numbering ? response.data.eoi_numbering : {};
            agencyProject.eoi_starting_no = eoiNumbering.eoi_starting_no === undefined ? params.eoi_starting_no : eoiNumbering.eoi_starting_no;

            let message = 'Agency settings saved successfully.';
            if (eoiNumbering.next_eoi_no) {
                message += ' Next EOI No.: ' + eoiNumbering.next_eoi_no;
            }
            self.SSAlertService.success(message);
            self.hideAgencyProjectEditForm();
        });
    }

    /**
     * WEB-4467: Whether the EOI starting number in the open form differs from the saved one.
     *
     * @param {Object|null} agencyProject The saved link, or null/undefined for a link not assigned yet.
     * @returns {boolean} False when the user may not edit it, so a DMS_PROJ_ADD_AGENCY-only user
     *                    assigning an agency never hits the DMS_PROJ_EDIT_AGENCY-guarded endpoint.
     */
    isEoiStartingNoChanged(agencyProject) {
        const self = this;

        if (!self.canEditEoiStartingNo()) {
            return false;
        }

        return self.normalizeEoiStartingNo(self.agencyProjectParams.eoi_starting_no)
            !== self.normalizeEoiStartingNo(agencyProject ? agencyProject.eoi_starting_no : null);
    }

    /**
     * WEB-4467: The EOI starting number is saved by POST sec/developer/agencies/eoi-numbering,
     * which the server guards with DMS_PROJ_EDIT_AGENCY on the project.
     *
     * @returns {boolean}
     */
    canEditEoiStartingNo() {
        const self = this;

        return self.SSUserService.hasPermissionForProperty('DMS_PROJ_EDIT_AGENCY', self.data.property.id);
    }

    /**
     * WEB-4467: Empty / invalid → null (no starting number), otherwise an integer.
     *
     * @param {*} value The model value (number input gives a number, undefined when invalid, or null).
     * @returns {number|null}
     */
    normalizeEoiStartingNo(value) {
        if (value === undefined || value === null || value === '') {
            return null;
        }

        let number = parseInt(value, 10);

        return isNaN(number) ? null : number;
    }

    // ------------ WEB-4489: commission claimable email (server WEB-4488)

    /**
     * WEB-4489: reset the "Commission claimable email" section of the edit row.
     *
     * @returns {void} self.commissionEmail = {loading, rules, selectedRuleId, form, startDate, errors}
     */
    resetCommissionEmail() {
        const self = this;

        self.commissionEmail = {
            loading: false,
            loaded: false,
            rules: [],
            selectedRuleId: null,
            form: {},
            startDate: null,
            errors: {},
        };
    }

    /**
     * WEB-4489: GET the commission claimable email rule(s) covering this agency–project link.
     *
     * @param {Object} agencyProject The link being edited (needs id and agency_id).
     * @returns {void}
     *
     * @remarks Usually 0 or 1 rule. A rule set up in DMS → Settings may cover several projects.
     *          Requests are tagged with the agency id so a slow reply for a row the user has since
     *          left cannot fill the row now open (same as getEoiNumbering()).
     */
    loadCommissionNotification(agencyProject) {
        const self = this;

        self.resetCommissionEmail();
        if (!agencyProject || !agencyProject.id || !agencyProject.agency_id || !self.canViewCommissionEmail()) {
            return;
        }

        let agencyId = agencyProject.agency_id;
        let params = {
            property_id: self.data.property.id,
            agency_id: agencyId,
        };

        self.commissionEmail.loading = true;
        self.SSHttpService.getAPIRequest('sec/developer/agencies/commission-notification', params).then(function (response) {
            if (self.agencyProjectParams.agency_id != agencyId) {
                return;
            }
            self.commissionEmail.loading = false;

            if (response instanceof Error) {
                // Non-blocking: the rest of the edit row still works
                console.warn('WEB-4489: Unable to load the commission claimable email.', response);
                return;
            }

            self.commissionEmail.loaded = true;
            self.commissionEmail.rules = (response.data && response.data.commission_notifications) || [];
            self.selectCommissionRule(self.commissionEmail.rules.length ? self.commissionEmail.rules[0].id : null);
        });
    }

    /**
     * WEB-4489: show one rule in the form (or the defaults for a new one).
     *
     * @param {number|null} ruleId
     * @returns {void}
     *
     * @remarks A new rule's form starts switched OFF (QA, WEB-4489 comment 49988: an agency with
     *          no email set up showed "On"), monthly on the 1st. The user switches it on to start
     *          sending; saving with the switch off stores a rule that is not sent.
     */
    selectCommissionRule(ruleId) {
        const self = this;
        const S = self.ScheduleService;

        let rule = self.findCommissionRule(ruleId);

        self.commissionEmail.selectedRuleId = rule ? rule.id : null;
        self.commissionEmail.errors = {};
        self.commissionEmail.form = rule ? self.commissionRuleToForm(rule) : {
            is_enabled: 0,
            emails: '',
            frequency: S.FREQUENCY_MONTHLY,
            schedule_day: null,
        };
        self.commissionEmail.startDate = rule ? S.toDate(rule.schedule_start_date) : null;
    }

    /**
     * @param {number|null} ruleId
     * @returns {Object|null} The loaded rule with that id.
     */
    findCommissionRule(ruleId) {
        const self = this;

        if (!ruleId || !self.commissionEmail) {
            return null;
        }

        return self.commissionEmail.rules.find(x => x.id == ruleId) || null;
    }

    /**
     * WEB-4489: a rule's editable values in form shape (numbers for the selects, 1/0 for the switch).
     *
     * @param {Object} rule
     * @returns {{is_enabled: number, emails: string, frequency: (number|null), schedule_day: (number|null)}}
     */
    commissionRuleToForm(rule) {
        const self = this;
        const S = self.ScheduleService;

        return {
            is_enabled: (rule.is_enabled === false || rule.is_enabled === 0 || rule.is_enabled === '0') ? 0 : 1,
            emails: rule.emails || '',
            frequency: S.toNumberOrNull(rule.frequency),
            schedule_day: S.toNumberOrNull(rule.schedule_day),
        };
    }

    /**
     * WEB-4489: label for the rule picker shown when 2+ rules cover this link.
     *
     * @param {Object} rule
     * @returns {string}
     */
    getCommissionRuleLabel(rule) {
        const self = this;

        let label = self.ScheduleService.describeSchedule(rule);
        let recipients = self.ScheduleService.splitEmails(rule.emails);
        if (recipients.length) {
            label += ' — ' + recipients[0] + (recipients.length > 1 ? ' +' + (recipients.length - 1) : '');
        }

        return label;
    }

    /**
     * WEB-4489: how many OTHER projects the selected rule also covers.
     *
     * @returns {number}
     */
    getCommissionRuleSharedCount() {
        const self = this;

        let rule = self.findCommissionRule(self.commissionEmail && self.commissionEmail.selectedRuleId);
        if (!rule || !rule.property_ids) {
            return 0;
        }
        let propertyId = String(self.data.property.id);

        return String(rule.property_ids).split(',')
            .map(id => id.trim())
            .filter((id, index, ids) => id && id !== propertyId && ids.indexOf(id) === index)
            .length;
    }

    /**
     * WEB-4489: frequency changed — a weekday and a day of the month are not interchangeable.
     *
     * @returns {void}
     */
    onCommissionFrequencyChange() {
        const self = this;

        self.commissionEmail.form.schedule_day = null;
        delete self.commissionEmail.errors.schedule_day;
        delete self.commissionEmail.errors.schedule_start_date;
    }

    /**
     * WEB-4489: GET is guarded by DMS_PROJ_VIEW_AGENCY on the project.
     *
     * @returns {boolean}
     */
    canViewCommissionEmail() {
        const self = this;

        return self.SSUserService.hasPermissionForProperty('DMS_PROJ_VIEW_AGENCY', self.data.property.id);
    }

    /**
     * WEB-4489: POST is guarded by DMS_PROJ_EDIT_AGENCY on the project (+ 2FA session).
     *
     * @returns {boolean}
     */
    canEditCommissionEmail() {
        const self = this;

        return self.SSUserService.hasPermissionForProperty('DMS_PROJ_EDIT_AGENCY', self.data.property.id);
    }

    /**
     * WEB-4489: the fields to POST — every field for a new rule, only the changed ones otherwise
     * (the server keeps the saved value of an omitted field).
     *
     * @returns {Object} Without property_id / agency_id / developer_email_notification_id.
     *
     * @remarks For a fortnightly rule schedule_day is never compared or sent: the server derives
     *          it from the start date, so it would otherwise always look changed.
     */
    buildCommissionNotificationChanges() {
        const self = this;
        const S = self.ScheduleService;

        let form = self.commissionEmail.form;
        let desired = angular.extend({
            emails: S.splitEmails(form.emails).join(','),
            is_enabled: form.is_enabled ? 1 : 0,
        }, S.buildSchedule(form, self.commissionEmail.startDate));

        let rule = self.findCommissionRule(self.commissionEmail.selectedRuleId);
        if (desired.frequency === S.FREQUENCY_FORTNIGHTLY) {
            delete desired.schedule_day;
        }
        if (!rule) {
            return desired;
        }

        let saved = {
            emails: S.splitEmails(rule.emails).join(','),
            is_enabled: self.commissionRuleToForm(rule).is_enabled,
            frequency: S.toNumberOrNull(rule.frequency),
            schedule_day: S.toNumberOrNull(rule.schedule_day),
            schedule_start_date: rule.schedule_start_date ? String(rule.schedule_start_date).substr(0, 10) : null,
        };

        let changes = {};
        Object.keys(desired).forEach(function (field) {
            if (desired[field] !== saved[field]) {
                changes[field] = desired[field];
            }
        });

        return changes;
    }

    /**
     * WEB-4489: SAVE (create / update / switch on-off) the commission claimable email of the open
     * agency–project link via POST sec/developer/agencies/commission-notification.
     *
     * @returns {void}
     *
     * @remarks Saved on its own button, separately from the commission/incentives Submit, because it
     *          is a different record (a developer_email_notifications row that may cover several
     *          projects). The same row is listed in DMS → Settings → Email Notifications. Server
     *          field messages (412001) show under the fields; 412003 (rule gone) reloads the section.
     */
    saveCommissionNotification() {
        const self = this;
        const S = self.ScheduleService;

        if (!self.canEditCommissionEmail() || !self.agencyProjectParams || !self.agencyProjectParams.id) {
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function (data) {
                let errors = S.validateSchedule(self.commissionEmail.form, self.commissionEmail.startDate, true);
                let emailError = S.validateEmails(self.commissionEmail.form.emails);
                if (emailError) {
                    errors.emails = emailError;
                }
                self.commissionEmail.errors = errors;
                if (Object.keys(errors).length) {
                    self.SSAlertService.warning('Missing Params!', 'Please correct the commission claimable email settings.');
                    return;
                }

                let changes = self.buildCommissionNotificationChanges();
                if (!Object.keys(changes).length) {
                    self.SSAlertService.info('No changes', 'The commission claimable email settings are unchanged.');
                    return;
                }

                let agencyId = self.agencyProjectParams.agency_id;
                let params = angular.extend({
                    property_id: self.data.property.id,
                    agency_id: agencyId,
                }, changes);
                if (self.commissionEmail.selectedRuleId) {
                    params.developer_email_notification_id = self.commissionEmail.selectedRuleId;
                }

                loading(true);
                self.SSHttpService.postAPIRequest('sec/developer/agencies/commission-notification', params).then(function (response) {
                    loading(false);
                    if (self.agencyProjectParams.agency_id != agencyId) {
                        return;
                    }

                    if (response instanceof Error) {
                        if (response.sub_code == 412003) {
                            self.SSAlertService.danger('Error!', 'This email setting no longer exists. It has been reloaded.');
                            self.loadCommissionNotification(self.agencyProjectParams);
                            return;
                        }
                        self.commissionEmail.errors = S.parseFieldErrors(response);
                        if (Object.keys(self.commissionEmail.errors).length) {
                            self.SSAlertService.warning('Not saved', 'Please correct the highlighted commission claimable email fields.');
                        } else {
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                        return;
                    }

                    let saved = response.data && response.data.commission_notification;
                    if (saved) {
                        let index = self.commissionEmail.rules.findIndex(x => x.id == saved.id);
                        if (index >= 0) {
                            self.commissionEmail.rules.splice(index, 1, saved);
                        } else {
                            self.commissionEmail.rules.push(saved);
                        }
                        self.selectCommissionRule(saved.id);
                    }
                    self.SSAlertService.success('Commission claimable email saved successfully.');
                });
            }
        );
    }

    deleteAgencyProject(agencyProject) {
        const self = this;

        self.SSConfirmationService.getConfirmed('Confirm Delete!',
            'Are you sure you want to delete this agency?',
            self.SSConfirmationService.TYPE_DEFAULT,
            function () {
                let url = 'sec/developer/agencies/remove';
                let params = {
                    property_id: agencyProject.property_id,
                    agency_id: agencyProject.agency_id,
                };

                loading(true);
                self.SSHttpService.postAPIRequest(url, params).then(function (response) {
                    loading(false);

                    if (response instanceof Error) {
                        self.SSAlertService.parseAndDisplayError(response);
                        self.agencyProjectErrors = self.SSHttpService.parseErrors(response);
                        return;
                    }
                    self.SSAlertService.success('Agency removed successfully.');

                    jQuery.each(self.agencyProjects, function (i, _agencyProject) {
                        if (agencyProject.id == _agencyProject.id) {
                            self.agencyProjects.splice(i, 1);
                            return false;
                        }
                    });

                    self.filterAvailableAgencies();
                });
            }
        );
    }

    exportCommissions() {
        const self = this;

        const propertyId = self.data.property.id;
        const url = self.SSHttpService.getApiURL(`sec/developer/properties/${propertyId}/export-unit-commission-n-incentives`);

        loading(true);
        self.$window.open(url, '_blank');
        loading(false);
    }

    triggerFileInput() {
        document.getElementById('commissionImportFile').click();
    }

    importCommissions($files) {
        const self = this;

        if (!$files || $files.length === 0) {
            return;
        }

        const file = $files[0];

        if (!self.validateFileType(file)) {
            self.SSAlertService.error('Invalid File Type', 'Please select an Excel (.xlsx, .xls) or CSV (.csv) file.');
            self.resetFileInput();
            return;
        }

        self.OTPService.getVerified(
            self.OTPService.TYPE_SESSION_2FA,
            function(data) {
                self.isImporting = true;
                loading(true);

                const propertyId = self.data.property.id;
                const url = self.SSHttpService.getApiURL(`sec/developer/properties/${propertyId}/import-unit-commission-n-incentives`);

                self.Upload.upload({
                    url: url,
                    method: 'POST',
                    data: {
                        file: file,
                        property_id: propertyId
                    },
                    withCredentials: true
                }).then(
                    function(response) {
                        loading(false);
                        self.isImporting = false;
                        self.resetFileInput();

                        if (response.data && response.data.message) {
                            self.SSAlertService.success('Import Successful', response.data.message);
                        } else {
                            self.SSAlertService.success('Import Successful', 'Agency commissions imported successfully.');
                        }

                        self.getAppointedAgencies();
                    },
                    function(response) {
                        loading(false);
                        self.isImporting = false;
                        self.resetFileInput();

                        if (response.data && response.data.error) {
                            self.SSAlertService.error('Import Failed', response.data.error);
                        } else {
                            self.SSAlertService.parseAndDisplayError(response);
                        }
                    }
                );
            },
            function() {
                self.resetFileInput();
            }
        );
    }

    validateFileType(file) {
        if (!file) {
            return false;
        }

        const validMimeTypes = [
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'text/csv'
        ];

        const validExtensions = ['xlsx', 'xls', 'csv'];

        const fileExtension = file.name.split('.').pop().toLowerCase();
        const isMimeValid = validMimeTypes.includes(file.type);
        const isExtensionValid = validExtensions.includes(fileExtension);

        return isMimeValid || isExtensionValid;
    }

    resetFileInput() {
        const fileInput = document.getElementById('commissionImportFile');
        if (fileInput) {
            fileInput.value = '';
        }
    }

    // ------------

    filterAvailableAgencies() {
        const self = this;

        if (self.agencies == null || self.agencyProjects == null)
            return;

        self.availableAgencies = [{
            id: null,
            name: "Please Select"
        }];

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, agency) {
                let agencyProject = self.findAgencyProject(agency.id);
                if (!agencyProject) {
                    self.availableAgencies.push({
                        id: agency.id,
                        name: agency.name
                    });
                }
            });
        }
    }

    findAgency(agencyId) {
        const self = this;

        let agency = null;

        if (self.agencies) {
            jQuery.each(self.agencies, function (i, _agency) {
                if (agencyId == _agency.id) {
                    agency = _agency;
                    return false;
                }
            });
        }

        return agency;
    }

    getAgencyName(agencyId) {
        const self = this;

        let agency = self.findAgency(agencyId);

        return agency ? agency.name : '';
    }

    isAgencyGstRegistered(agencyId) {
        const self = this;

        let agency = self.findAgency(agencyId);

        return agency && agency.profile ? agency.profile.gst_registered : false;
    }

    findAgencyProject(agencyId) {
        const self = this;

        let agencyProject = null;

        if (self.agencyProjects) {
            jQuery.each(self.agencyProjects, function (i, _agencyProject) {
                if (agencyId == _agencyProject.agency_id) {
                    agencyProject = _agencyProject;
                    return false;
                }
            });
        }

        return agencyProject;
    }

    // ------------

    showAgencyProjectEditForm(agencyProject) {
        const self = this;

        self.agencyProjectParams = {};
        self.agencyProjectErrors = {};

        if (!agencyProject) {
            agencyProject = {
                id: 0,
                property_id: self.data.property.id,
                editable: 1,
                availability: null,
            };
        }

        let found = false;

        if (self.agencyProjects) {
            jQuery.each(self.agencyProjects, function (i, _agencyProject) {
                if (agencyProject.id == _agencyProject.id) {
                    _agencyProject.editable = 1;
                    self.agencyProjectParams = angular.copy(_agencyProject);
                    found = true;
                } else {
                    if (_agencyProject.id) {
                        _agencyProject.editable = null;
                    } else {
                        self.agencyProjects.splice(i, 1);
                    }
                }
            });
        }

        if (!found) {
            self.agencyProjects.push(agencyProject);
            self.agencyProjectParams = angular.copy(agencyProject);
        }

        // WEB-4467: a number input needs a Number model (a string would render blank / throw numfmt)
        self.agencyProjectParams.eoi_starting_no = self.normalizeEoiStartingNo(self.agencyProjectParams.eoi_starting_no);
        self.getEoiNumbering(self.agencyProjectParams);
        self.loadCommissionNotification(self.agencyProjectParams);
    }

    hideAgencyProjectEditForm() {
        const self = this;

        if (!self.agencyProjects) {
            return;
        }

        jQuery.each(self.agencyProjects, function (i, _agencyProject) {
            if (_agencyProject.id) {
                _agencyProject.editable = null;
            } else {
                self.agencyProjects.splice(i, 1);
            }
        });

        self.agencyProjectParams = {};
        self.agencyProjectErrors = {};
        self.eoiNumbering = null;
        self.resetCommissionEmail();
    }

    // ------------

    formatValue(type, value, gst_inclusive) {
        const self = this;

        if (value == null)
            return '--';

        let _value = '';

        if (!type || type == 10) {
            _value = self.SSUtilService.formatPercentage(value);
        } else if (type == 20) {
            _value = self.SSUtilService.formatCurrency(value);
        }

        _value += gst_inclusive == 1 ? ' (With GST)' : ' (Without GST)';

        return _value;
    }

}

DeveloperAgencyController.$inject = ['$scope', '$window', 'SSHttpService', 'SSUtilService', 'SSAlertService', 'SSUserService', 'SSConfirmationService', 'OTPService', 'Upload', 'SSEmailNotificationScheduleService'];
app.controller('DeveloperAgencyController', DeveloperAgencyController);
